import { useEffect, useState } from 'react';
import { listNoteTypes } from './api';
import type { NoteType } from './types';

/**
 * The category codes a note type accepts, or null when no restriction applies: no type (an R2 note,
 * or no note chosen) or the list could not be read (the server then still refuses what it must).
 */
export function useAllowedCategories(
  noteType: NoteType | null | undefined,
): ReadonlySet<string> | null {
  const [allowed, setAllowed] = useState<ReadonlySet<string> | null>(null);
  useEffect(() => {
    if (!noteType) {
      setAllowed(null);
      return;
    }
    let live = true;
    void listNoteTypes().then((outcome) => {
      if (live) setAllowed(outcome.ok ? new Set(outcome.value[noteType]) : null);
    });
    return () => {
      live = false;
    };
  }, [noteType]);
  return allowed;
}
